import type { ReduxDispatch } from 'types/services/redux';
import { oneApi } from 'utils/api/api-fetcher';

export const authentication = (dispatch: ReduxDispatch) => (isAuthenticated: boolean, apiToken?: string) => {
  if (apiToken && isAuthenticated) {
    oneApi.setUseAuth(true);
  }

  dispatch({ type: 'AUTH', isAuthenticated, apiToken });

  if (apiToken && isAuthenticated) {
    oneApi.setUseAuth(true);
  }
};

export const login = (dispatch: ReduxDispatch) => () => dispatch({ type: 'LOGIN' });

export const logout = (dispatch: ReduxDispatch) => () => dispatch({ type: 'LOGOUT' });
